import { authApiService } from '@/api/authApiService';
import { ApiParams } from '@/api/helpers/apiHelpers';
import { ApiResponseType, ListResponseType } from '@/types/sharedTypes';
import { InternalOrganizationListUserType } from '@/bundle/_MasterAdmin/types/types';

export const getInternalOrganizationUsersApi = async (
  params?: ApiParams
): Promise<ApiResponseType<ListResponseType<InternalOrganizationListUserType>>> => {
  const uri = '/organization/internal/users/';

  return authApiService.GET(uri, params);
};
